import type { PortableTextBlock, PortableTextComponents, PortableTextMarkComponent } from '@portabletext/react';
import { PortableText } from '@portabletext/react';
import type { StudioPathLike } from '@sanity/client/csm';
import { ScopeDataAttribute } from '../infrastructure/DataAttributeContext';
import { ActionButton } from './ActionButton';
import { ExternalLink } from './externalLink';
import { FileComponentHyperlink } from './FileComponentHyperlink';
import { InternalLink } from './internalLink';
import { Phrase } from './Phrase';
import { PopoverMark } from './PopoverMark';

export const marks: Record<string, PortableTextMarkComponent> = {
    link: ExternalLink,
    fileComponent: FileComponentHyperlink,
    internalLink: InternalLink,
    popoverMark: PopoverMark,
    actionButton: ActionButton,
};

const simpleRichTextComponents: Partial<PortableTextComponents> = {
    marks,
    types: {
        phrase: Phrase,
    },
};

export default function SimpleRichText({ value, studioPath = 'richText' }: { value: PortableTextBlock[]; studioPath?: StudioPathLike }) {
    return (
        value && (
            <ScopeDataAttribute path={studioPath}>
                <PortableText value={value} components={simpleRichTextComponents} />
            </ScopeDataAttribute>
        )
    );
}
